<div class="text-center" >

    <button class="close" mat-button (click)="onNoClick()"><i class="fa fa-times"></i></button>
    <div class="text-center">
        <div  class="embed-responsive embed-responsive-16by9 center">


            <iframe width="560" height="315" [src]="this.video_url" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>        </div>

    </div>
</div>
